import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const dividerVariants = cva([], {
  variants: {
    orientation: {
      horizontal: ["border-b"],
      vertical: ["border-l "]
    },
    variant: {
      default: ["border-separator-color"],
      light: ["border-separator-color-light"],
      dark: ["border-separator-color-dark"]
    }
  },
  defaultVariants: {
    orientation: "horizontal",
    variant: "default"
  }
});
const Divider = forwardRef((props, ref) => {
  const { className, orientation, variant, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { ref, ...rest, className: twMerge(dividerVariants({ orientation, variant, className })) });
});
export {
  Divider as default
};
//# sourceMappingURL=Divider.js.map
